import $ from 'jquery';
import eventBus from 'EventBus';
import util from 'util/Util';
import themeService from 'ThemeService';
import undoService from 'UndoService';
import pageSyncService from 'PageSyncService';
import focusController  from 'FocusController';
import BasePropertyView from 'BasePropertyView';
import formatTemplate from 'properties/theme/buttons.ejs';
import { pickerCfg } from 'pickerCfg';
import Immutable        from 'immutable';
import fontService from 'FontService';
class ButtonsView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);
        
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.initializeTextAttributes();
        this.model.set('buttonStyle', themeService.resolve('~buttonStyle'), { silent: true });
        this.model.set('buttonBgColor', themeService.resolve('~buttonBgColor'), { silent: true });
        this.model.set('buttonBgGradientColor', themeService.resolve('~buttonBgGradientColor'), { silent: true });
        this.model.set('buttonBgDownColor', themeService.resolve('~buttonBgDownColor'), { silent: true });
        this.model.set('buttonBgGradientDownColor', themeService.resolve('~buttonBgGradientDownColor'), { silent: true });
        this.model.set('buttonBgOverColor', themeService.resolve('~buttonBgOverColor'), { silent: true });
        this.model.set('buttonBgGradientOverColor', themeService.resolve('~buttonBgGradientOverColor'), { silent: true });

        this.model.set('buttonRadius', themeService.resolve('~buttonRadius'), { silent: true });

        this.events = {
            'change input[type=text]': 'updateAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change select': 'updateSelectAttributes',
            'click .styleSelectorButton': 'updateTextStyleAttributes',
            'click .weightSelectorButton': 'updateTextWeightAttributes'
        };


        // Don't change this name without realizing that the base class may assume this name
        this.dropdownPropNames = Immutable.List(
            ['buttonStyle', 'buttonFont', 'buttonFontSize', 'buttonRadius']);


        return this;
    }

    initializeTextAttributes() {
        this.model.set('buttonTextColor', themeService.resolve('~buttonTextColor'), { silent: true });
        this.model.set('buttonTextDownColor', themeService.resolve('~buttonTextDownColor'), { silent: true });
        this.model.set('buttonTextOverColor', themeService.resolve('~buttonTextOverColor'), { silent: true });

        let fontProp = themeService.resolve('~buttonFont').split(',');

        this.model.set('buttonFont', fontProp[0].trim(), { silent: true });
        this.model.set('buttonFontSize', fontProp[1].trim(), { silent: true });

        if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('bold') > -1) ||
            (fontProp[3] && fontProp[3].toLowerCase().indexOf('bold') > -1)) {
            this.model.set('buttonTextWeight', 'bold !important', { silent: true });
        } else {
            this.model.set('buttonTextWeight', 'normal !important', { silent: true });
        }
        if (this.model.get('buttonTextWeight') === 'normal !important') {
            this.model.set('buttonTextWeightSelection', this.unselectedColor, { silent: true });
        } else {
            this.model.set('buttonTextWeightSelection', this.selectedColor, { silent: true });
        }

        if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('italic') > -1) ||
            (fontProp[3] && fontProp[3].toLowerCase().indexOf('italic') > -1)) {
            this.model.set('buttonTextStyle', 'italic !important', { silent: true });
        } else {
            this.model.set('buttonTextStyle', 'normal !important', { silent: true });
        }
        if (this.model.get('buttonTextStyle') === 'normal !important') {
            this.model.set('buttonTextStyleSelection', this.unselectedColor, { silent: true });
        } else {
            this.model.set('buttonTextStyleSelection', this.selectedColor, { silent: true });
        }
    }

    updateThemeFontAttributes() {
        const themePropArray = [this.model.get('buttonFont'), this.model.get('buttonFontSize'), this.model.get('buttonTextWeight'), this.model.get('buttonTextStyle')];
        themeService._theme['~buttonFont'] = themePropArray.join(',');
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;

        let style = this.model.get(propName);
        let oldValue = this.model.get(propName);

        if (this.model.get(propName).indexOf('italic') > -1) {
            this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
            style = 'normal !important';
        } else {
            this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
            style = 'italic !important';
        }

        this.model.set(propName, style, { silent: true });
        this.updateThemeFontAttributes();
        this.render();
        eventBus.trigger('ButtonThemeChange');

        undoService.add({
            undo: () => {
                if (oldValue.indexOf('italic') > -1) {
                    this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
                } else {
                    this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
                }
                this.model.set(propName, oldValue, { silent: true });
                this.updateThemeFontAttributes();

                //eventBus.trigger('InputThemeChange');
                //this.model.trigger('change', this.model);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            },
            redo: () => {
                if (style.indexOf('italic') > -1) {
                    this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
                } else {
                    this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
                }
                this.model.set(propName, style, { silent: true });
                this.updateThemeFontAttributes();

                //eventBus.trigger('InputThemeChange');
                //this.model.trigger('change', this.model);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            }
        })
    }

    updateTextWeightAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;

        let weight = this.model.get(propName);
        let oldValue = this.model.get(propName);

        if (this.model.get(propName).indexOf('bold') > -1) {
            this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
            weight = 'normal !important';
        } else {
            this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
            weight = 'bold !important';
        }

        this.model.set(propName, weight, { silent: true });
        this.updateThemeFontAttributes();
        this.render();
        eventBus.trigger('ButtonThemeChange');

        undoService.add({
            undo: () => {
                if (oldValue.indexOf('bold') > -1) {
                    this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
                } else {
                    this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
                }
                this.model.set(propName, oldValue, { silent: true });
                this.updateThemeFontAttributes();

                //eventBus.trigger('InputThemeChange');
                //this.model.trigger('change', this.model);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            },
            redo: () => {
                if (weight.indexOf('italic') > -1) {
                    this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
                } else {
                    this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
                }
                this.model.set(propName, weight, { silent: true });
                this.updateThemeFontAttributes();

                //eventBus.trigger('InputThemeChange');
                //this.model.trigger('change', this.model);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            }
        })
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const propColorName = propName.replace('Color', '');
        const oldThemeValue=themeService._theme['~' + propName];
        const oldPropVal = this.model.get(propName);
        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);

            this.model.set(propName, color, { silent: true });
            this.render();
            $('#' + propName).val(color);
            themeService._theme['~' + propName] = color;
            eventBus.trigger('ButtonThemeChange');
            this.addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,color);
        } else {
            this.model.set(propName, $('#' + propColorName).val());
        }
    }

    updateColorAttributes(ev) {
        ev.preventDefault();

        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropVal = this.model.get(propName);
        const oldThemeValue=themeService._theme['~' + propName];

        //let name = propName;
        let color = this.resolveColor(propVal);

        this.model.set(propName, color, { silent: true });
        this.render();
        $('#' + propName).val(color);
        themeService._theme['~' + propName] = color;
        eventBus.trigger('ButtonThemeChange');
        this.addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,color);
    }

    addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,currentColor){
        undoService.add({
            undo:() => {
                this.model.set(propName, oldPropVal,{silent:true});
                themeService._theme['~' + propName] = oldThemeValue;
                //eventBus.trigger('InputThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
                $('#' + propName).val(oldPropVal);
            },
            redo: () => {
                this.model.set(propName, currentColor,{silent:true});
                themeService._theme['~' + propName] = currentColor;
                //eventBus.trigger('InputThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
                $('#' + propName).val(currentColor);
            }
        })
    }

    updateSelectAttributes(ev, name, val) {
        ev.preventDefault();
        const propName = name || ev.currentTarget.name;
        const propVal = val || ev.currentTarget.value;
        const oldPropVal=this.model.get(propName);
        let oldThemeVal=themeService._theme['~buttonFont'];

        this.model.set(propName, propVal,{silent:true});
        if (propName === 'buttonStyle') {
            oldThemeVal=themeService._theme['~buttonStyle'];
            themeService._theme['~buttonStyle'] = propVal;
        } else if (propName === 'buttonRadius') {
            oldThemeVal=themeService._theme['~buttonRadius'];
            themeService._theme['~buttonRadius'] = propVal;
        } else {
            this.updateThemeFontAttributes();
        }
        this.render();
        eventBus.trigger('ButtonThemeChange');

        undoService.add({
            undo:() => {
              this.model.set(propName, oldPropVal,{silent:true});
                if (propName === 'buttonStyle') {
                    themeService._theme['~buttonStyle'] = oldThemeVal;
                } else if (propName === 'buttonRadius') {
                    themeService._theme['~buttonRadius'] = oldThemeVal;
                } else {
                  this.updateThemeFontAttributes();
                }
                //eventBus.trigger('InputThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            },
            redo: () => {
              this.model.set(propName, propVal,{silent:true});
                if (propName === 'buttonStyle') {
                    themeService._theme['~buttonStyle'] = propVal;
                } else if (propName === 'buttonRadius') {
                    themeService._theme['~buttonRadius'] = propVal;
                } else {
                  this.updateThemeFontAttributes();
                }
                //eventBus.trigger('InputThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            }
        })
    }


    render() {
        super.render();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        util.prepareComboWidget(this.$el, this);

        this.createEditableDropDown('buttonFontSize');

        const fonts = fontService.loadFontsDropDown(false);
        $("#buttonFont").append(fonts);

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.updateForm();
        this.delegateEvents();
        return this;
    }

}

export default ButtonsView;
